import { TemporalEntityId } from 'utils'

import { Check, CheckLogic } from '../logic'

export type InvestorChecksState = {
  readonly isFetching: boolean
  readonly items: IdIndexedInvestorChecks
  readonly isFetchingAvailableChecks: boolean
  readonly availableChecks: ChecksConfig[]
}

export type ChecksConfig = {
  readonly id: CheckLogic
  readonly dataType: ChecksTypes
  readonly display: {
    label: string
    placeholder?: string
  }
  readonly config?: SelectConfig
  readonly deprecated?: boolean
}

export enum ChecksTypes {
  select = 'select',
  advancedSelect = 'advanced-select',
  boolean = 'boolean',
  numeric = 'numeric',
  text = 'text',
  time = 'time',
  yearRangeSelect = 'year-range-select',
}

export type SelectConfig = {
  readonly isMulti?: boolean
  readonly entity?: string
}

export type IdIndexedInvestorChecks = {
  readonly [investorCheckId: number]: InvestorCheck
}

export type InvestorCheck = {
  readonly id: number
  readonly checkType: CheckType
  readonly checkLogic: Check['logic']
  readonly checkData: Check['data']
}

export const newInvestorCheck = (checkType: CheckType) => {
  return {
    id: TemporalEntityId.new,
    checkType,
    checkLogic: '',
    checkData: {},
  }
}

export enum CheckType {
  criterion = 'criterion',
  signal = 'signal',
}

export const CHECKS_LEVEL_WEIGHTS = {
  [CheckType.criterion]: 3,
  [CheckType.signal]: 1,
}

export const INVESTOR_CHECKS_STORE_ID = 'investorChecks'
